import styled from "styled-components";

type ContainerType = {
    background: string;
    heightShowingHeaderInfo: number;
};

export const Container = styled.div<ContainerType>`
  display: flex;
  flex: 1;
  height: calc(100vh - 101px - ${props => `${props.heightShowingHeaderInfo}px`});
  flex-direction: column;
  background: ${(props) => props.background};
  overflow: auto;
  padding-right: 2px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 0;
  gap: 16px;
`;
